<template>
  <div id="tasklist">
    <div class="container">
      <!-- 普通和活动的导航栏 -->
      <div class="tabbar">
        <div :class="['boxleft',{active: current==0}]" @click="leftBoxshow">普通</div>
        <div :class="['boxright',{active: current==1}]" @click="rightBoxshow">活动</div>
      </div>

      <!--空数据展示-->

      <div class="blankimg" v-show="list[current].down.length === 0">
        <img class="imgBlock" src="../../assets/task/task(10).png" />
      </div>

      <!-- 普通对应的盒子 -->
      <div v-if="current==0" class="ulBox">
        <div class="smallBox" v-for="(n,index) in list[0].down" :key="index">
          <div
            :class="['boxIcon']"
            @click="clickSportIcon(n)"
            :style="{ width: width + 'px', height: width + 'px'}"
          >
            <img :src="n.picSrc" :class="{gray_img:n.finished == '0'}" />
          </div>
          <p class="boxdec apostrophe" :style="{width: width + 'px'}">{{n.medalname}}</p>
        </div>
      </div>
      <!-- 活动对应的盒子 -->
      <div v-if="current==1" class="ulBox">
        <div class="smallBox" v-for="(n,index) in list[1].down" :key="index">
          <div
            :class="['boxIcon']"
            @click="clickSportIcon(n)"
            :style="{ width: width + 'px', height: width + 'px'}"
          >
            <img :src="n.picSrc" :class="{gray_img:n.finished == '0'}" />
          </div>
           <p class="boxdec apostrophe" :style="{width: width + 'px'}">{{n.medalname}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tasklist",
  props: ["list"],
  data() {
    return {
      current: 0,
      tc_img_obj: {},
      // 宽度
      width: 0,
    };
  },
  mounted() {
    // 动态设置礼物盒子的宽高
    this.width = this.calculateWidthHeight();
  },
  methods: {
    leftBoxshow() {
      this.current = 0;
    },
    rightBoxshow() {
      this.current = 1;
    },
    // 点击普通和活动的小图标
    clickSportIcon(item) {
      this.tc_img_obj = item;
      this.$emit("get_big_img", item);
    },
    // 计算宽度
    calculateWidthHeight: () => {
      let ulBox = document.querySelector('.ulBox');
      let fatherWidth = ulBox.offsetWidth;
      return fatherWidth*0.199
    },
  }
};
</script>

<style scoped>
#tasklist {
  background-color: #fff;
}

.gray_img {
  filter: grayscale(100%) !important;
}
.blankimg {
  width: 33%;
  margin: 0 auto;
  margin-top: 10%;
}
.container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  background-color: rgba(219, 202, 202, 0.2);
  border-radius: 8px;
}
.tabbar {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: auto;
  width: 45%;
  height: 30px;
  line-height: 30px;
  background-color: rgba(255, 255, 255, 0.16);
  border-radius: 22px;
  color: #fff;
  font-size: 12px;
  margin-top: 8px;
}
.tabbar div {
  width: 50%;
  text-align: center;
}
.tabbar .boxleft,
.tabbar .boxright {
  width: 70px;
  height: 24px;
  line-height: 24px;
  position: absolute;
  top: 3px;
}
.tabbar .boxleft {
  left: 3px;
}
.tabbar .boxright {
  right: 3px;
}
.tabbar .active {
  background-color: #ffd856;
  width: 45%;
  height: 24px;
  line-height: 24px;
  border-radius: 18px;
  color: #bb3215;
  text-align: center;
}

.ulBox {
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  margin: auto;
  width: 90%;
  border-radius: 10%;
  padding: 10px 0;
  overflow-y: scroll;
  box-sizing: border-box;
}
.smallBox {
  height: 80px;
  margin: 7px 0;
  margin-right: 6.7%;
  text-align: center;
}
.smallBox:nth-child(4n) {
  margin-right: 0;
}
.smallBox .boxIcon {
  border-radius: 10%;
  overflow: hidden;
}
.smallBox .boxIcon img {
  width: 100%;
  height: 100%;
  border: none;
}
.smallBox .boxdec {
  color: #ffffff;
  font-size: 12px;
  margin-top: 3px;
  text-align: center;
}

/* 点击活动的弹出框样式 */
.bigIconBox img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  -webkit-animation: show-f-top 0.3s ease-out;
  animation: show-f-top 0.3s ease-out;
}
/* 图片显示的动画 */
/*元素从顶部滑到屏幕中间*/
@keyframes show-f-top {
  from {
    transform: translateX(-50%) translateY(-100%);
  }
  to {
    transform: translateX(-50%) translateY(0);
  }
}
@-webkit-keyframes show-f-top {
  /* Safari 和 Chrome */
  from {
    transform: translateX(-50%) translateY(-100%);
  }
  to {
    transform: translateX(-50%) translateY(0);
  }
}

/* 活动弹出的大图片盒子 */
.bigIconBox .centerInfo {
  position: absolute;
  top: 330px;
  width: 100%;
  text-align: center;
  -webkit-animation: fadein 0.4s ease-in;
  animation: fadein 0.4s ease-in;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  /* Safari 和 Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bigIconBox .centerInfo p:nth-child(1) {
  color: #fff;
  font-size: 20px;
  height: 50px;
  line-height: 50px;
}
.bigIconBox .centerInfo p:nth-child(2) {
  color: #fff;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}
.bigIconBox .centerInfo p:nth-child(3) {
  color: #fff;
  font-size: 12px;
  height: 50px;
  line-height: 50px;
}
/* 返回按钮的样式 */
.bigIconBox .backBtn {
  position: absolute;
  bottom: 150px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  text-align: center;
  font-size: 14px;
  color: #bb3215;
  background: linear-gradient(#f9d352, rgb(238, 173, 20));
}
</style>